@if (loading) {
  <div class="align-items-center d-flex h-100 justify-content-center mx-auto">
    <app-slim-spinner> </app-slim-spinner>
  </div>
}

@if (!loading) {
  <div class="explore-container" [id]="imageAlt">
    <div class="explore-left">
      <div class="title-container">
        @for (part of titleParts; track part; let i = $index) {
          <h2 class="title" [innerHTML]="part"></h2>
        }
      </div>
      <p class="description">{{ description }}</p>
      <button class="cta-button hover-none" (click)="ctaClick(successModal)">
        {{ ctaText }}
        <img src="/assets/images/right-arrow-white.svg" alt="explore cta" />
      </button>
    </div>
    <div class="explore-right">
      <img [src]="imageSrc" alt="Product illustration" class="product-image" />
    </div>
  </div>
}

<ng-template #successModal>
  <div class="dialog-content">
    <div class="image-container">
      <img
        src="/assets/home/thank-you-support.svg"
        alt="Support Representative"
        />
    </div>
    <div class="text-container">
      <div class="close-button-container">
        <img
          (click)="closeDialog()"
          class="help-screen-close-button"
          src="/assets/svg/model-close-btn.svg"
          alt="close"
          />
      </div>
      <h2><span>Thank You!</span> We have captured your interest.</h2>
      <p>Our Sales executive will get in touch with you soon.</p>
      <button class="cta-button hover-none" (click)="closeDialog()">OK</button>
    </div>
  </div>
</ng-template>
